import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Renderer2, Inject, OnDestroy, ChangeDetectorRef, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router"
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from '@services/security';
import { LoaderService } from '@modules/loader';
import { AppConsts } from '@shared/app-consts';
import { ResetPasswordModel } from '@shared/ResetPasswordModel';
import _ from 'lodash';
import { GRecaptchaService } from '@services/grecaptcha.service';


@Component({
  selector: 'app-new-password',
  templateUrl: './newpassword.component.html',
  styleUrls: ['./newpassword.component.scss']
})
export class NewPasswordComponent implements OnInit {
  resetPasswordForm: FormGroup;
  resetPasswordModel: ResetPasswordModel;
  email: string;
  infoMessage: string;
  userId: string;
  token: string;
  step: number = 1;
  page: string;
  isError: boolean = false;
  submitted: boolean = false;
  submitWithCaptcha = GRecaptchaService.submitWithCaptcha;

  get f() { return this.resetPasswordForm.controls; }

  constructor(private service: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    public formBuilder: FormBuilder,
    private changeDedectionRef: ChangeDetectorRef,
    private loaderService: LoaderService, private renderer: Renderer2,
    @Inject(DOCUMENT) private _document, private zone: NgZone) {
  }


  ngOnInit() {
    this.initialize();
  }

  ngAfterContentChecked(): void {
    this.changeDedectionRef.detectChanges();
  }

  initialize() {
    this.step = 1;
    this.token = this.route.snapshot.queryParams["token"];
    this.userId = this.route.snapshot.queryParams["userId"];
    this.page = this.route.snapshot.queryParams["page"];
    if (_.isEmpty(this.userId) || _.isEmpty(this.token))
      this.router.navigate(['/login']);
    this.resetPasswordModel = new ResetPasswordModel(this.userId, this.token, this.page);
    this.buildForm();
  }

  buildForm() {
    this.resetPasswordForm = this.formBuilder.group({
      newPassword: ["",
        Validators.compose([
          Validators.minLength(8),
          Validators.required,
          Validators.pattern(AppConsts.PASSWORD_PATTERN)
        ])],
      confirmPassword: ["",
        Validators.compose([
          Validators.minLength(8),
          Validators.required,
          Validators.pattern(AppConsts.PASSWORD_PATTERN)
        ])]
    }, { validator: this.checkPasswords });

    this.resetPasswordForm.controls['newPassword'].valueChanges.subscribe((value) => {
      this.resetPasswordModel.NewPassword = value;
    });
    this.resetPasswordForm.controls['confirmPassword'].valueChanges.subscribe((value) => {
      this.resetPasswordModel.ConfirmNewPassword = value;
    });
  }

  checkPasswords(group: FormGroup) {
    let pass = group.get('newPassword').value;
    let confirmPass = group.get('confirmPassword').value;

    return pass === confirmPass ? null : { notSame: true }
  }

  handleValidSubmit = (event) =>{
    event.preventDefault();
    this.submitWithCaptcha(this.resetPassword.bind(this),event,"submit");
  }

  resetPassword(event, recaptchaToken) {
    this.submitted = true;
    if (this.resetPasswordForm.invalid)
      return;
    this.loaderService.showLoader();
    this.resetPasswordModel.RecaptchaToken = recaptchaToken;
    this.service.setNewPassword(this.resetPasswordModel).subscribe((response: any) => {
      this.loaderService.hideLoader();
      if (response != null && response == true) {
        this.step = 2;
      }
      else {
        this.isError = true;
      }
    }, (error) => {
      this.loaderService.hideLoader();
    });
  }

  redirectToLogin() {
    this.router.navigate(['/login']);
  }
}
